import React from "react";
import { Reveal, Eyebrow } from "./common";
import { Button } from "./ui/button";
import { Waves, Sun, LifeBuoy, MessageCircle, Car, MapPin, Clock, BadgeCheck, ArrowRight } from "lucide-react";

const Partners = () => (
  <section className="py-16">
    <div className="container-x">
      <div className="text-center max-w-2xl mx-auto mb-10">
        <Eyebrow>Local partners · San Juan del Sur</Eyebrow>
        <h2 className="font-display text-4xl md:text-5xl text-white leading-[1.05]">Make the most of your trip</h2>
        <p className="text-slate-300 mt-3">Two local resources we love — for planning your days on the water and getting around Nicaragua with zero stress.</p>
      </div>
      <div className="grid md:grid-cols-2 gap-6">
        {/* SJDS.app */}
        <Reveal>
          <div className="card-hover h-full rounded-2xl border border-white/10 bg-gradient-to-br from-[#0b4f49] to-[#0e2740] p-7 flex flex-col">
            <div className="flex items-center gap-3 mb-3">
              <span className="rounded-xl bg-white/10 p-2.5 text-[#5cf0d8]"><Waves className="h-6 w-6" /></span>
              <div><h3 className="font-heading text-2xl text-white leading-none">SJDS.app</h3><p className="text-xs text-slate-300 mt-1">The San Juan del Sur community app</p></div>
            </div>
            <p className="text-slate-200 text-sm">Live surf reports, tide charts, weather radar, moon calendar, earthquake &amp; tsunami alerts, community chat and a full local business directory — everything you need for SJDS in one place.</p>
            <div className="flex flex-wrap gap-2 my-4">
              {[[Waves,"Surf & tides"],[Sun,"Weather radar"],[LifeBuoy,"Safety alerts"]].map(([Icon,t]) => (<span key={t} className="inline-flex items-center gap-1.5 rounded-full bg-white/5 px-3 py-1 text-xs text-slate-200"><Icon className="h-3.5 w-3.5 text-[#5cf0d8]" /> {t}</span>))}
            </div>
            <a href="https://sjds.app" target="_blank" rel="noreferrer" className="mt-auto"><Button className="btn-gold w-full gap-2">Open SJDS.app <ArrowRight className="h-4 w-4" /></Button></a>
          </div>
        </Reveal>
        {/* NicaraguaTaxi */}
        <Reveal delay={0.12}>
          <div className="card-hover h-full rounded-2xl border border-white/10 bg-gradient-to-br from-[#123a5c] to-[#0e2740] p-7 flex flex-col">
            <div className="flex items-center gap-3 mb-3">
              <span className="rounded-xl bg-white/10 p-2.5 text-[#f5a524]"><Car className="h-6 w-6" /></span>
              <div><h3 className="font-heading text-2xl text-white leading-none">NicaraguaTaxi.com</h3><p className="text-xs text-slate-300 mt-1">Taxi &amp; transport across Nicaragua</p></div>
            </div>
            <p className="text-slate-200 text-sm">Set fares on 200+ routes — Managua &amp; Liberia airport transfers, Peñas Blancas border pickups, beach-hopping around San Juan del Sur, and long-distance rides. Bilingual, licensed local drivers.</p>
            <div className="flex flex-wrap gap-2 my-4">
              {[[BadgeCheck,"Fixed prices"],[Clock,"24/7 service"],[MapPin,"Airport & border"]].map(([Icon,t]) => (<span key={t} className="inline-flex items-center gap-1.5 rounded-full bg-white/5 px-3 py-1 text-xs text-slate-200"><Icon className="h-3.5 w-3.5 text-[#f5a524]" /> {t}</span>))}
            </div>
            <div className="mt-auto flex gap-2">
              <a href="https://nicaraguataxi.com/book" target="_blank" rel="noreferrer" className="flex-1"><Button className="btn-gold w-full gap-2">Book a Ride <ArrowRight className="h-4 w-4" /></Button></a>
              <a href="https://wa.me/19168498896" target="_blank" rel="noreferrer"><Button variant="outline" className="border-[#25D366] text-[#25D366] bg-transparent hover:bg-[#25D366]/10"><MessageCircle className="h-4 w-4" /></Button></a>
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);

export default Partners;
